import { render, staticRenderFns } from "./CopyLinkModal.vue?vue&type=template&id=9a625b52&scoped=true&"
import script from "./CopyLinkModal.vue?vue&type=script&lang=js&"
export * from "./CopyLinkModal.vue?vue&type=script&lang=js&"
import style0 from "./CopyLinkModal.vue?vue&type=style&index=0&id=9a625b52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a625b52",
  null
  
)

export default component.exports